import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';

interface Props {
  value?: boolean;
  absolute?: boolean;
  spinnerOffsetTop?: string | number;
  minHeight?: string | number;
  fullHeight?: boolean;
  background?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'PagePreloader',
  props: {
    value: { type: Boolean, default: false },
    absolute: { type: Boolean, default: false },
    spinnerOffsetTop: { default: 0 },
    minHeight: { default: 0 },
    fullHeight: { type: Boolean, default: true },
    background: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { value: boolean, absolute: boolean, spinnerOffsetTop: string | number, minHeight: string | number, fullHeight: boolean, background: boolean };


const preloaderStyles = computed(() => {
  const styles: Record<string, any> = {};

  if (+props.minHeight) styles['min-height'] = `${Number(props.minHeight)}px`;

  if (+props.spinnerOffsetTop)
    styles['padding-top'] = `${Number(props.spinnerOffsetTop)}px`;

  return styles;
});

return { __sfc: true,props, preloaderStyles }
}

})